import { Apple } from 'lucide-react';
import { useI18n } from '../i18n/useI18n';

const appStoreUrl = 'https://apps.apple.com/us/app/ddproof-camera/id6772867892';
const googlePlayUrl =
  'https://play.google.com/store/apps/details?id=com.ddproof.camera';

function GooglePlayMark() {
  return (
    <span className="google-play-mark" aria-hidden="true">
      <span className="google-play-mark-top" />
      <span className="google-play-mark-bottom" />
      <span className="google-play-mark-point" />
    </span>
  );
}

export function StoreBadges() {
  const { t } = useI18n();

  return (
    <div className="store-badges" aria-label={t('download.storeLinks')}>
      <a
        className="store-badge"
        href={appStoreUrl}
        target="_blank"
        rel="noreferrer"
      >
        <Apple size={27} strokeWidth={1.8} aria-hidden="true" />
        <span>
          <span>{t('download.appStorePrefix')}</span>
          <strong>{t('download.appStore')}</strong>
        </span>
      </a>
      <a
        className="store-badge"
        href={googlePlayUrl}
        target="_blank"
        rel="noreferrer"
      >
        <GooglePlayMark />
        <span>
          <span>{t('download.googlePlayPrefix')}</span>
          <strong>{t('download.googlePlay')}</strong>
        </span>
      </a>
    </div>
  );
}
